import React from 'react'
import { connect } from 'react-redux'
import TextField from '@mui/material/TextField'
import { Button, Grid, Typography, CardContent } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import MrtReusableTable from '../../Utils/MrtReusableTable'
import { getDeviceStatus } from '../../../store/DeviceStatuses/actionCreator'
import {
  handleFireflySendEvent,
  handleFireflySendClickEvent,
} from '../../Utils/FireFlyVnextHelpers'

export class StoreDeviceStatuses extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      deviceList: [],
      loading: false,
      storesInput: '',
    }
    this.handleOnSearch = this.handleOnSearch.bind(this)
    this.baseState = { ...this.state }
  }

  async componentDidMount() {
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'Store Device Statuses Tab',
        'Store Device Statuses Tab Load',
        userInfo,
      )
    }
  }

  static defaultProps = {
    userInfo: {
      email: undefined,
    },
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.deviceList.length) {
      this.setState({
        deviceList: JSON.parse(JSON.stringify(nextProps.deviceList)),
      })
    }
  }

  async handleOnSearch(event) {
    const { userInfo } = this.props
    handleFireflySendClickEvent(
      'CLICK',
      'Store Device Statuses Tab',
      'Store Device Statuses - Submit',
      userInfo,
    )
    event.preventDefault()
    this.setState({ ...this.baseState, loading: true })
    await this.props.getDeviceStatus(this.state.storesInput)
    this.setState({ loading: false })
  }

  render() {
    let devices = []
    if (this.state.deviceList.length > 0) {
      const deviceColumns = [
        { header: 'Hostname', accessorKey: 'name' },
        { header: 'Type', accessorKey: 'type', size: 400 },
        {
          header: 'Status',
          accessorKey: 'status',
          muiTableBodyCellProps: ({ cell }) => {
            const value = cell.getValue()
            let backgroundColor = '#bdbdbd' // default gray
            if (
              value.toLowerCase() === 'online' ||
              value.toLowerCase() === 'good'
            ) {
              backgroundColor = '#228B22'
            } else backgroundColor = '#FF0000'
            return {
              style: {
                backgroundColor: backgroundColor,
              },
            }
          },
        },
      ]

      const defaultColumns = ['name', 'type', 'status']

      devices = (
        <MrtReusableTable
          pageSize={[10, 20, 50]}
          pageTitle={'Devices'}
          columns={deviceColumns}
          rowData={this.props.deviceList}
          defaultColumns={defaultColumns}
          loading={this.state.loading}
          loadingMessage="Loading Devices..."
        />
      )
    } else {
      devices = this.state.deviceList
    }

    const devicePanel = <div>{devices}</div>

    return (
      <CardContent
        style={{
          height: '90%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          overflowY: 'auto',
        }}
      >
        {this.state.loading ? (
          <Grid
            container
            spacing={16}
            justifyContent={'center'}
            className="progress"
          >
            <CircularProgress />
            <Typography className="loading">&nbsp;Loading...</Typography>
          </Grid>
        ) : (
          <Grid item size={{ xs: 12 }}>
            <Grid container spacing={16}>
              <Grid item style={{ width: 1100 }}>
                <Typography gutterBottom>
                  Enter a list of locations numbers with commas between each. To
                  help prevent issues, limit to 8 or fewer locations.
                </Typography>
                <br />
                <form onSubmit={this.handleOnSearch}>
                  <TextField
                    type="text"
                    variant="standard"
                    id="standard-multiline-flexible"
                    multiline
                    maxRows="4"
                    value={this.state.storesInput}
                    onChange={(event) =>
                      this.setState({ storesInput: event.target.value })
                    }
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === 'Return') {
                        this.handleOnSearch(event)
                      }
                    }}
                    placeholder="T0003,T0004, etc"
                    required
                    sx={{ width: 500, height: 80 }}
                    slotProps={{ className: 'redUnderline' }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!this.state.storesInput}
                    type="submit"
                    sx={{ margin: '8px' }}
                  >
                    submit
                  </Button>
                </form>
              </Grid>
            </Grid>
            <Grid container spacing={16}>
              <Grid item size={{ xs: 12 }}>
                {this.state.deviceList.length > 0 ? (
                  typeof this.state.deviceList[0] === 'string' ? (
                    <Typography variant="h4">
                      {this.state.deviceList}
                    </Typography>
                  ) : (
                    devicePanel
                  )
                ) : (
                  ''
                )}
              </Grid>
            </Grid>
          </Grid>
        )}
      </CardContent>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    deviceList: state.deviceStatuses.deviceList,
    userInfo: state.auth.userInfo,
  }
}

const mapDispatchToProps = {
  getDeviceStatus,
}

export default connect(mapStateToProps, mapDispatchToProps)(StoreDeviceStatuses)
